import { Helper } from '../Helper';
export class ThrowTypeErrorHelper extends Helper {
    emit(sb, node, options) {
        sb.emitPushString(node, 'TypeError');
        sb.emitHelper(node, options, sb.helpers.wrapString);
        sb.emitHelper(node, options, sb.helpers.throw);
    }
}

//# sourceMappingURL=ThrowTypeErrorHelper.js.map
